import BaseUseCase from "../../base_use_case.js";
import Routes from "../../../admin/routes.js";

class ListDownloadablesUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/downloadables/downloadables`,
      params: params
    }).then((result) => {
      let { data, headers } = result;
      let { downloadables } = data;

      downloadables = downloadables.map((downloadable) => {
        return {
          ...downloadable,
          id: downloadable.slug,
          key: downloadable.slug,
          itemLink: Routes.downloadable(downloadable)
        }
      })
      data.list = downloadables;
      return { data, headers }
    })
  }
}

const instance = new ListDownloadablesUseCase();
export default instance;
